export {
  parseAccountSummaryData,
  matchAccountsWithSummaries,
  parseBankDetailData,
  extractTransactionSpecificDetails,
  matchLedgerWithWorksheetDetail,
  parsePaymentData,
};

function parseAccountSummaryData(summaryData) {
  //NOTE: ASSUMES THE FOLLOWING FORMAT
  //NOTE: acctCode|acctType|acctCur|reptCur|ledgerDate|bkBal|bkReconBal|rcnt|bkUnreconBal|urcnt|clBalance|clcnt|pdrflag|cdrflag

  let arrKeys = [
    "acctCode",
    "acctTypeSort",
    "curCode",
    "reptCur",
    "ledgerDate",
    "begBal",
    "bkReconBal",
    "bkReconCnt",
    "bkUnreconBal",
    "bkUnreconCnt",
    "cdReconBal",
    "cdReconCnt",
    "cdUnreconBal",
    "cdUnreconCnt",
    "clUnreconAmt",
    "clCnt",
    "pdrFlag",
    "pdDate",
    "cdrFlag",
    "cdDate",
  ];
  let arrData = summaryData.split("|");
  let summaryObject = {};

  // console.log("KEYCOUNT: " + arrKeys.length + " DATACOUNT: " + arrData.length);
  try {
    if (arrKeys.length == arrData.length) {
      arrKeys.forEach((key, idx) => {
        summaryObject[key] = arrData[idx];
        // console.log("SETTING: " + key + " TO: " + arrData[idx]);
      });
    }
  } catch (error) {
    console.log("PARSE ERROR:", error);
  }

  return summaryObject;
}

function matchAccountsWithSummaries(acctArray, summaryArray) {
  //NOTE: THESE SHOULD BE ARRAYS OF OBJECTS
  //DETAIL: THE ACCOUNT AND SUMMARY SHOULD MATCH UP BASED ON 'acctCode' (DON'T ASK)
  //NOTE: THIS ACTUALLY MANIPULATES THE ACCTARRAY OBJECT SO NO NEED TO 'return' ANYTHING
  //DETAIL: THERE IS ONLY ONE SUMMARY (BALANCE) PER ACCOUNT . . . HOWEVER AT SOME POINT IN THE APPLICATION WE NEED TO GRAB ACTUAL TRANSACTIONS THAT MAKE UP SAID BALANCE
  acctArray.forEach((acct) => {
    for (let i = 0; i < summaryArray.length; i++) {
      if (acct.acctCode == summaryArray[i].acctCode) {
        // console.log("ACCTCODE SUCCESS: " + acct.acctCode);
        //DETAIL (matchAccountsWithSummaries): Performing balance adjustments based on desktop application function `getcalculatedEndingBalanceAmt`
        summaryArray[i].calculatedEndingBalance = parseFloat(summaryArray[i].begBal);

        if (acct.balanceIsSetAutomatically) {
          summaryArray[i].calculatedEndingBalance =
            parseFloat(summaryArray[i].begBal) +
            parseFloat(summaryArray[i].cdReconBal) +
            parseFloat(summaryArray[i].cdUnreconBal);
        } else {
          if (acct.acctType == "Credit Line") {
            //NOTE: SKIPPING FOR NOW AS THIS DEPENDS ON A SEPARATE METHOD CALL TO ACQUIRE ANY CREDIT AMOUNTS (NO IDEA WHY IT'S NOT ALL RETRIEVED INITIALLY)
          }
        }
        acct.summary = summaryArray[i];
      }
    }
  });
}

function parseBankDetailData(bankDetailData) {
  //NOTE: ASSUMES A TAB-DELIMITED FORMAT IN HARMONY WITH 'arrKeys'

  let arrKeys = [
    "rid",
    "balanceID",
    "acctCode",
    "currency",
    "reportType",
    "typeCode",
    "typeDescription",
    "valueDatedItem",
    "posted",
    "valueDate",
    "ledgerDate",
    "amount",
    "amt0Day",
    "amt1Day",
    "amt2Day",
    "amt3Day",
    "amt4Day",
    "amt5Day",
    "ref1",
    "ref2",
    "description",
    "comments",
    "reconStatus",
    "reconDate",
    "reconUserID",
    "isSummaryEntry",
    "transfers",
    "CLSourceID",
    "origValueDate",
    "subAcctID",
    "balanceReptType",
  ];
  let arrData = bankDetailData.split("\t");
  let bankDetailObject = {};

  try {
    // if (arrKeys.length == arrData.length) {
    arrKeys.forEach((key, idx) => {
      bankDetailObject[key] = arrData[idx] ?? "NO DATA";
    });
    // }
  } catch (error) {
    console.log("PARSE ERROR:", error);
  }

  return bankDetailObject;
}

function extractTransactionSpecificDetails(infoObject, source = "") {
  // NOTE: `type` will be 'ledgerEntry' or 'bankDetail'
  // console.log("EXTRACTING:", infoObject);

  //NOTE: `infoObject` COULD BE A LEDGER ITEM OR A BANK DETAILS ITEM
  let transactionObject = Object.create(null);

  transactionObject["originalSource"] = source;
  transactionObject["rid"] = infoObject.rid;
  transactionObject["valueDate"] = infoObject.valueDate;
  transactionObject["amount"] = infoObject.amount;
  transactionObject["comments"] = infoObject.comments;
  transactionObject["transferStatus"] =
    source == "ledgerEntry"
      ? `${infoObject.transferMethod}/${infoObject.transferStatus}`
      : infoObject.reportType;
  transactionObject["reconStatus"] = infoObject.reconStatus;
  transactionObject["reconDate"] = infoObject.reconDate;
  transactionObject["reconUserID"] = infoObject.reconUserID;

  //ACCOUNT FOR POTENTIAL DIFFERENCES IN OBJECTS
  transactionObject["txnCode"] =
    source == "ledgerEntry"
      ? infoObject.txnCode
      : `${infoObject.typeCode} - ${infoObject.typeDescription}`;

  return transactionObject;
}

function matchLedgerWithBankDetail(ledgerTransactions, bankDetailArray) {
  // WARNING: THIS IS NO LONGER USED.  IT WAS BASED ON A MISUNDERSTANDING OF `acctSummaryList.ExpandRow` METHOD IN THE DESKTOP APP THAT PULLED LEDGER ITEMS AND BANK DETAILS
  // WARNING: . . .IN REALITY, THEY ARE PEERS!!!
  //NOTE: THESE SHOULD BE ARRAYS OF OBJECTS
  // ledgerTransactions.forEach((transaction) => {
  //   for (let i = 0; i < bankDetailArray.length; i++) {
  //     if (transaction.rid == bankDetailArray[i].rid) {
  //       // console.log(`********* WE GOT A MATCH(${transaction.rid}) *********`);
  //       transaction.detail = bankDetailArray[i];
  //     }
  //   }
  // });
}

function matchLedgerWithWorksheetDetail(ledgerTransactions, worksheetDetailArray) {
  ledgerTransactions.forEach((transaction) => {
    for (let i = 0; i < worksheetDetailArray.length; i++) {
      let stringToMatch = `(${transaction.rid})`;
      if (worksheetDetailArray[i].indexOf(stringToMatch) > -1) {
        // console.log(`********* WE GOT A WORKSHEET MATCH(${transaction.rid}) *********`);
        transaction.worksheetDetail = worksheetDetailArray[i];
      }
    }
  });
}

function parsePaymentData(paymentData) {
  let arrKeys = [
    "rid",
    "entity",
    "debit_acct_code",
    "debit_acct_number",
    "curCode",
    "valueDate",
    "amount",
    "reconStatus",
    "reconDate",
    "xfrMethod",
    "xfrStatus",
    "xfrDate",
    "xfrBatch",
    "txnCodeDetailID",
    "txnCode",
    "templateID",
    "comments",
    "wtr_purpose",
    "wtr_status",
    "wtr_statusDate",
    "wtr_enqueDate",
    "wtr_transmitDate",
    "wtr_confirmDate",
    "wtr_completedDate",
    "wtr_signatureID",
    "wtr_approvalDate",
    "wtr_approver",
    "xfrCreator",
    "xfrDelvInstructID",
    "xfrDelvInstructCode",
    "wtr_releasedBy",
    "wtr_releaseDate",
    "wtr_templateID",
    "fxRefID",
    "fiRefID",
    "entrySource",
    "txnFamily",
    "regulatory_pop_text",
    "email_notice_flag",
    "attachments",
  ];

  let arrData = paymentData.split("\t");
  let paymentObject = Object.create(null);

  // console.log("KEYCOUNT: " + arrKeys.length + " DATACOUNT: " + arrData.length);
  try {
    // if (arrKeys.length == arrData.length) {
    arrKeys.forEach((key, idx) => {
      paymentObject[key] = arrData[idx] ?? "NO DATA";
    });
    // }
  } catch (error) {
    console.log("PARSE ERROR:", error);
  }

  return paymentObject;
}

// CASH POSITION FUNCTIONS
function parseCashPositionEntry(positionData) {
  let arrData = positionData.split("\t");
  let positionObject = Object.create(null);
}
